// src/pages/Authentication/UserProfile/WorkInfoCard.tsx
// Read-only work information card

import React from 'react';
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

interface WorkInfoCardProps {
  department: string;
  position: string;
  roleGroup: string;
  joinDate: string;
}

const WorkInfoCard: React.FC<WorkInfoCardProps> = ({
  department,
  position,
  roleGroup,
  joinDate,
}) => {
  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">
          <i className="ri-building-line me-2"></i>
          {st('thong_tin_cong_tac_title')}
        </h5>
      </CardHeader>

      <CardBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="form-label">{st('phong_ban_don_vi_label')}</Label>
              <Input
                type="text"
                value={department}
                disabled
                className="bg-light"
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label className="form-label">{st('chuc_vu_label')}</Label>
              <Input
                type="text"
                value={position}
                disabled
                className="bg-light"
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label className="form-label">{st('nhom_quyen_label')}</Label>
              <Input
                type="text"
                value={roleGroup}
                disabled
                className="bg-light"
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label className="form-label">{st('ngay_vao_lam_label')}</Label>
              <Input
                type="text"
                value={joinDate}
                disabled
                className="bg-light"
              />
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default WorkInfoCard;